import React from 'react'
import styled from 'styled-components'

const Img = styled.img`
  width: 16px;
  border-radius: 5px;
`
const ImgSpan = styled.span`
  display: inline-block;
  width: 16px;
  height: 16px;
  background: #ffcc00;
  color: white;
  text-align: center;
  line-height: 16px;
  border-radius: 5px;
`
const HeadImg = (props) => {
  const {url, name, width = 16, height = 16} = props
  if (url) {
    return <Img src={url} alt="头像" style={{width: width, height: height}}/>
  } else {
    if (name && name.length) {
      return <ImgSpan style={{width: width, height: height, lineHeight: `${height}px`, fontSize: width > 20 ? 14 : 12 }}>
        {name.substring(0,1)}
      </ImgSpan>
    } else {
      return null
    }
  }
}

export default HeadImg
